<!-- Журнал -->
<template>
  <li
    v-if="canSeePage('activity_logs')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'ActivityLog')"
    @mouseup="handleMiddleClick($event, 'ActivityLog')"
    @contextmenu.prevent.stop="showContextMenu($event, 'ActivityLog')"
    :class="{ active: activeItem === 'activity-log' }"
    :title="collapsed ? 'Журнал' : ''"
  >
    <div class="link-icon_box">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        class="activity-log-svg"
      >
        <path
          d="M3 12a9 9 0 1 0 3-6.7L3 8"
        />
        <path d="M3 3v5h5" />
        <path d="M12 7v5l3 2" />
      </svg>
    </div>
    <AppSidebarItemLabel
      label="Журнал"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "ActivityLogItem",
  components: { AppSidebarItemLabel },
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
